// extracted by mini-css-extract-plugin
export default {"status":"ServerError_status__CY8KK","title":"ServerError_title__0Mz5Y","message":"ServerError_message__iFBkL"};